(() => {
  const initHeightProduct = (root) => {
    if (root.dataset.heightInitialized === 'true') return;
    root.dataset.heightInitialized = 'true';
    const variantInput = root.querySelector('[data-height-variant-input]');
    const stickyInput = root.querySelector('[data-height-sticky-input]');
    const price = root.querySelector('[data-height-price]');
    const priceGroup = root.querySelector('[data-height-price-group]');
    const comparePrice = root.querySelector('[data-height-compare-price]');
    const saleBadge = root.querySelector('[data-height-sale-badge]');
    const atcPrice = root.querySelector('[data-height-atc-price]');
    const atcComparePrice = root.querySelector('[data-height-atc-compare-price]');
    const atcLabel = root.querySelector('[data-height-atc-label]');
    const atc = root.querySelector('[data-height-atc]');
    const stickyPrice = root.querySelector('[data-height-sticky-price]');
    const stickyComparePrice = root.querySelector('[data-height-sticky-compare-price]');
    const stickyOption = root.querySelector('[data-height-sticky-option]');
    const stickyAtc = root.querySelector('[data-height-sticky-atc]');
    const options = Array.from(root.querySelectorAll('[data-height-option]'));

    const soleOptions = Array.from(root.querySelectorAll('[data-sole-option]'));
    const selectVariant = (button, updateUrl = true) => {
      if (!button) return;
      const soleChanged = root.dataset.sole !== button.dataset.sole;
      updateSole(button.dataset.sole);
      if (soleChanged) showSlide(0);

      options.forEach((option) => {
        const selected = option === button;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
      });

      const variantId = button.dataset.variantId;
      const formattedPrice = button.dataset.price;
      const formattedComparePrice = button.dataset.comparePrice || '';
      const label = button.dataset.variantLabel;
      const available = button.dataset.available === 'true';

      const updateComparePrice = (element) => {
        if (!element) return;
        element.textContent = formattedComparePrice;
        element.hidden = !formattedComparePrice;
      };

      if (variantInput) variantInput.value = variantId;
      if (stickyInput) stickyInput.value = variantId;
      if (price) price.textContent = formattedPrice;
      updateComparePrice(comparePrice);
      if (atcPrice) atcPrice.textContent = formattedPrice;
      updateComparePrice(atcComparePrice);
      if (stickyPrice) stickyPrice.textContent = formattedPrice;
      updateComparePrice(stickyComparePrice);
      if (stickyOption) stickyOption.textContent = label;
      if (saleBadge) saleBadge.hidden = !formattedComparePrice;
      if (priceGroup) {
        const regularPriceLabel = formattedComparePrice ? `, regular price ${formattedComparePrice}` : '';
        priceGroup.setAttribute('aria-label', `Current price ${formattedPrice}${regularPriceLabel}`);
      }

      if (atc) atc.disabled = !available;
      if (stickyAtc) stickyAtc.disabled = !available;
      if (atcLabel) atcLabel.textContent = available ? 'Get my pair' : 'Sold out';

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      if (updateUrl) window.history.replaceState({}, '', url);
      updateBundle();
    };

    const bundles = Array.from(root.querySelectorAll('[data-height-bundle]'));
    const updateBundle = () => {
      let bundle = bundles.find((input) => input.checked);
      const option = options.find((button) => button.classList.contains('is-selected'));
      if (!bundle || !option) return;
      const available = option.dataset.available === 'true';
      const maximum = available ? Number(option.dataset.maxQuantity ?? 9999) : 0;
      bundles.forEach(input => {
        input.disabled = Number(input.value) > maximum;
        input.closest('.tlh-bundle').classList.toggle('is-unavailable', input.disabled);
      });
      if (bundle.disabled) {
        bundle.checked = false;
        bundle = bundles.find(input => !input.disabled);
        bundle = bundle || bundles[0];
        bundle.checked = true;
      }
      const stockNote = root.querySelector('[data-height-stock-note]');
      if (stockNote) stockNote.textContent = !available ? 'This sole and lift is currently sold out.' : maximum < 3 ? 'Larger bundles are currently unavailable for this sole and lift. Choose another option or fewer pairs.' : '';
      const quantity = Number(bundle.value);
      const plural = quantity === 1 ? 'pair' : 'pairs';
      if (atc) atc.disabled = !available;
      if (stickyAtc) stickyAtc.disabled = !available;
      root.querySelectorAll('[data-height-quantity]').forEach((input) => { input.value = String(quantity); });
      bundles.forEach((input) => input.closest('.tlh-bundle').classList.toggle('is-selected', input === bundle));
      [price, atcPrice, stickyPrice].forEach((element) => { if (element) element.textContent = bundle.dataset.total; });
      // Bundle comparisons are the actual single-pair price multiplied by quantity, not a former selling price.
      [comparePrice, atcComparePrice, stickyComparePrice].forEach((element) => {
        if (!element) return;
        element.textContent = quantity > 1 ? bundle.dataset.regular : '';
        element.hidden = quantity === 1;
      });
      if (saleBadge) {
        saleBadge.hidden = quantity === 1;
        saleBadge.textContent = `Save ${bundle.dataset.saving}`;
      }
      if (atcLabel) atcLabel.textContent = available ? `Get ${quantity} ${plural}` : 'Sold out';
      if (stickyAtc) stickyAtc.textContent = available ? `Get ${quantity} ${plural}` : 'Sold out';
      if (stickyOption) stickyOption.textContent = `${quantity} ${plural} · ${option.dataset.variantLabel}`;
      const note = root.querySelector('[data-height-price-note]');
      if (note) note.textContent = `${quantity} ${plural} · Free shipping`;
      priceGroup?.setAttribute('aria-label', `${quantity} ${plural}, total ${bundle.dataset.total}${quantity > 1 ? `, ${bundle.dataset.regular} when bought individually` : ''}`);
    };
    bundles.forEach((input) => input.addEventListener('change', updateBundle));
    options.forEach((button) => button.addEventListener('click', () => selectVariant(button)));


    const slides = Array.from(root.querySelectorAll('[data-height-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-height-thumb]'));
    const counter = root.querySelector('[data-height-counter]');
    const gallery = root.querySelector('[data-height-gallery]');
    const viewport = root.querySelector('[data-height-viewport]');
    const thumbRail = root.querySelector('.tlh-gallery__thumbs');
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === activeIndex;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
      });
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;

      const activeThumb = thumbs[activeIndex];
      if (thumbRail && activeThumb) {
        const left = activeThumb.offsetLeft - (thumbRail.clientWidth - activeThumb.offsetWidth) / 2;
        thumbRail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    };

    root.querySelector('[data-height-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    root.querySelector('[data-height-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.index))));

    gallery?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showSlide(activeIndex + 1);
    });

    let touchStartX = 0;
    let touchStartY = 0;
    let trackingTouch = false;

    viewport?.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
        trackingTouch = true;
      },
      { passive: true }
    );

    viewport?.addEventListener(
      'touchend',
      (event) => {
        if (!trackingTouch || event.changedTouches.length !== 1) return;
        trackingTouch = false;

        const deltaX = event.changedTouches[0].clientX - touchStartX;
        const deltaY = event.changedTouches[0].clientY - touchStartY;
        const isHorizontalSwipe = Math.abs(deltaX) >= 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;

        if (isHorizontalSwipe) showSlide(activeIndex + (deltaX < 0 ? 1 : -1));
      },
      { passive: true }
    );

    viewport?.addEventListener('touchcancel', () => {
      trackingTouch = false;
    });

    const updateSole = (sole) => {
      root.dataset.sole = sole;
      soleOptions.forEach(button => {
        const selected = button.dataset.soleOption === sole;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      options.forEach(button => { button.hidden = button.dataset.sole !== sole; });
      root.querySelectorAll('[data-sole-content]').forEach(element => {
        element.hidden = element.dataset.soleContent !== sole;
      });
      const prefix = sole === 'half' ? 'soleHalf' : 'soleFull';
      root.querySelectorAll('[data-sole-full-src]').forEach(img => {
        const source = img.dataset[prefix + 'Src'];
        if (source && img.getAttribute('src') !== source) img.setAttribute('src', source);
        img.alt = img.dataset[prefix + 'Alt'] || '';
      });
      root.querySelectorAll('[data-sole-full-text]').forEach(element => {
        element.textContent = element.dataset[prefix + 'Text'] || '';
      });
    };
    soleOptions.forEach(button => button.addEventListener('click', () => {
      const current = options.find(option => option.classList.contains('is-selected'));
      const candidates = options.filter(option => option.dataset.sole === button.dataset.soleOption);
      const next = candidates.find(option => option.dataset.lift === current?.dataset.lift)
        || candidates.find(option => option.dataset.available === 'true') || candidates[0];
      selectVariant(next);
    }));
    const restoreSelection = () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      const next = options.find(option => option.dataset.variantId === id)
        || options.find(option => option.classList.contains('is-selected'));
      selectVariant(next, false);
    };
    selectVariant(options.find(button => button.classList.contains('is-selected')));
    window.addEventListener('pageshow', restoreSelection);
    window.addEventListener('popstate', restoreSelection);
    showSlide(activeIndex);

    const mainAtc = root.querySelector('[data-height-atc]');
    if ('IntersectionObserver' in window && mainAtc) {
      const stickyObserver = new IntersectionObserver(
        ([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          root.classList.toggle('is-sticky-visible', show);
          root.querySelector('[data-height-sticky]')?.setAttribute('aria-hidden', String(!show));
        },
        { threshold: 0.1 }
      );
      stickyObserver.observe(mainAtc);
    }
  };

  const initAll = () => document.querySelectorAll('[data-height-product]').forEach(initHeightProduct);
  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
